import * as React from 'react'

export const useViewport = () => {
  const [width, setWidth] = React.useState(document.documentElement.clientWidth)

  React.useEffect(() => {
    const handleWindowResize = () =>
      setWidth(document.documentElement.clientWidth)

    window.addEventListener('resize', handleWindowResize)
    return () => window.removeEventListener('resize', handleWindowResize)
  }, [])

  return { width }
}
